const round2 = (valor) => Math.round((valor + Number.EPSILON) * 100) / 100;

const num = (valor) => {
	const convertido = Number(valor);
	return Number.isFinite(convertido) ? convertido : 0;
};

// Arredonda o desconto das variações de um mesmo produto pai distribuindo a sobra
// de centavos pelo maior resto, para a coluna fechar exatamente com o total do pai.
const distribuirCentavos = (grupos) => {
	const alvo = Math.round(grupos.reduce((soma, g) => soma + g.descontoExato, 0) * 100);

	const base = grupos.map((g) => {
		const centavos = g.descontoExato * 100;
		const piso = Math.floor(centavos);
		return { grupo: g, piso, resto: centavos - piso };
	});

	let sobra = alvo - base.reduce((soma, b) => soma + b.piso, 0);
	if (sobra < 0) sobra = 0;
	if (sobra > base.length) sobra = base.length;

	base.sort((a, b) => b.resto - a.resto || b.grupo.brutoExato - a.grupo.brutoExato);
	base.forEach((b, indice) => {
		b.grupo.desconto = (b.piso + (indice < sobra ? 1 : 0)) / 100;
	});
};

export const agruparGrade = (rows = []) => {
	// Agrupa por produto pai + variação acumulando os valores exatos, sem arredondar.
	// O denominador do rateio vem pronto do servidor (total_grade), somado sobre todos os
	// complementos de grade do venda_item. Não dá para somar as linhas recebidas aqui:
	// com filtro por variação o servidor devolve só parte delas e o rateio sairia inflado.
	const grupos = new Map();
	rows.forEach((r) => {
		const totalItem = num(r.total_grade);
		const bruto = num(r.valor) > 0 ? num(r.valor) : num(r.valor_item);
		const rateio = totalItem > 0 ? num(r.desconto) * (num(r.valor) / totalItem) : 0;

		const chave = `${r.id_pai}|${r.id_variacao}`;
		let grupo = grupos.get(chave);

		if (!grupo) {
			grupo = {
				id_pai: r.id_pai,
				nome_pai: r.nome_pai,
				nome_variacao: r.nome_variacao,
				qt: 0,
				brutoExato: 0,
				descontoExato: 0,
			};
			grupos.set(chave, grupo);
		}

		grupo.qt += num(r.qtde);
		grupo.brutoExato += bruto;
		grupo.descontoExato += rateio;
	});

	const lista = [...grupos.values()];

	const porPai = new Map();
	lista.forEach((g) => {
		if (!porPai.has(g.id_pai)) porPai.set(g.id_pai, []);
		porPai.get(g.id_pai).push(g);
	});

	porPai.forEach((variacoes) => {
		distribuirCentavos(variacoes);

		variacoes.forEach((g) => {
			// Deriva o líquido do desconto já arredondado: bruto vem do banco com 2 casas,
			// então bruto - desconto fecha no centavo sem um segundo arredondamento.
			g.valor_total = round2(round2(g.brutoExato) - g.desconto);
		});
	});

	return lista
		.map((g) => ({
			nome_pai: g.nome_pai,
			nome_variacao: g.nome_variacao,
			qt: g.qt,
			desconto: g.desconto,
			valor_total: g.valor_total,
		}))
		.sort((a, b) => a.nome_pai.localeCompare(b.nome_pai) || b.qt - a.qt);
};

export const somarGrade = (lista = []) => ({
	qt: round2(lista.reduce((soma, g) => soma + g.qt, 0)),
	desconto: round2(lista.reduce((soma, g) => soma + g.desconto, 0)),
	valor_total: round2(lista.reduce((soma, g) => soma + g.valor_total, 0)),
});
